module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9620.b805331d.jpg";